'use client'

import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import main from '../../common/assets/images/solutions/predictive-maintrance/predictive-maintrance-main.webp';
import Image from "next/image";
import {ELEMENT_INDEX} from "../../common/constants/app";
import {ParagraphLine} from "@/app/[locale]/common/components/ParagraphLine/ParagraphLine";
import app_areas from '@/app/[locale]/common/assets/images/solutions/predictive-maintrance/app-areas.webp';
import app_areas_second_variant from '@/app/[locale]/common/assets/images/solutions/predictive-maintrance/app-areas-second-variant.webp';
import benefits from '@/app/[locale]/common/assets/images/solutions/predictive-maintrance/benefits.webp';
import {ConfirmIcon} from "@/app/[locale]/common/assets/ConfirmIcon/ConfirmIcon";
import {TCardContentIcon} from "@/app/[locale]/solutions/types";
import parameter_monitoring_engine from '@/app/[locale]/common/assets/images/solutions/predictive-maintrance/patameter-monitoring-engine.webp';
import parameter_monitoring_suspension from '@/app/[locale]/common/assets/images/solutions/predictive-maintrance/patameter-monitoring-suspension.webp';
import telematics_equipment from '@/app/[locale]/common/assets/images/solutions/predictive-maintrance/telematics-equipment.webp';
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import {Link} from '@/i18n/routing';
import {CircleArrowIcon} from "@/app/[locale]/common/assets/CircleArrowIcon/CircleArrowIcon";
import {TextIconLink} from "@/app/[locale]/common/components/TextIconLink/TextIconLink";
import {TProductsSliderCardProps} from "@/app/[locale]/common/components/ProductsSliderCard/types";
import {SliderBlock} from "@/app/[locale]/common/components/SliderBlock/SliderBlock";
import {useTranslations} from "next-intl";
import {
    addDataToTranslatedArray
} from "@/app/[locale]/common/utils/functions/addDataToTranslatedArray/addDataToTranslatedArray";
import {NumOneCircleIcon} from "@/app/[locale]/common/assets/NumOneCircleIcon/NumOneCircleIcon";
import {NumTwoCircleIcon} from "@/app/[locale]/common/assets/NumTwoCircleIcon/NumTwoCircleIcon";
import {NumTreeCircleIcon} from "@/app/[locale]/common/assets/NumTreeCircleIcon/NumTreeCircleIcon";
import {NumFourCircleIcon} from "@/app/[locale]/common/assets/NumFourCircleIcon/NumFourCircleIcon";
import {NumFiveCircleIcon} from "@/app/[locale]/common/assets/NumFiveCircleIcon/NumFiveCircleIcon";

export default function PredictiveMaintrancePage() {
    const t = useTranslations('PredictiveMaintrancePage');
    const implementingBlockData: TCardContentIcon[] = addDataToTranslatedArray(t.raw('implementingBlock.cardsData'), [NumOneCircleIcon, NumTwoCircleIcon, NumTreeCircleIcon, NumFourCircleIcon, NumFiveCircleIcon], 'Icon');

    return (
        <div className={s.predictiveMaintrance}>
            <Container>
                <Breadcrumbs crumb={[t.raw('breadcrumbs.SOLUTIONS'), t.raw('breadcrumbs.PREDICTIVE_MAINTRANCE')]}/>
                <div className={s.predictiveMaintrance_top}>
                    <Title title={t('title')}/>
                    <div
                        className={`${s.predictiveMaintrance_imageContainer} ${s.predictiveMaintrance_top_imageContainer}`}>
                        <Image src={main} alt={'main'}/>
                    </div>

                    <div className={`${s.predictiveMaintrance_flexContainer} ${s.predictiveMaintrance_top_content}`}>
                        {
                            t.raw('topBlock.text').map((item: string, index: number) => (
                                index === ELEMENT_INDEX.FIRST ?
                                    <p key={index}
                                       className={`${s.predictiveMaintrance_text} ${s.predictiveMaintrance_fullWidthText}`}>
                                        {item}
                                        <span
                                            className={`${s.predictiveMaintrance_text} ${s.predictiveMaintrance_top_selectedText}`}>{t('topBlock.selectedText')}</span>
                                    </p>
                                    : <ParagraphLine key={index}
                                                     className={`${s.predictiveMaintrance_text} ${s.predictiveMaintrance_fullWidthText}`}>{item}</ParagraphLine>
                            ))
                        }
                    </div>
                </div>

                <div className={s.predictiveMaintrance_appAreas}>
                    <Title title={t('appAreasBlock.title')}/>
                    <div
                        className={`${s.predictiveMaintrance_flexContainer} ${s.predictiveMaintrance_appAreas_content}`}>
                        {
                            t.raw('appAreasBlock.list').map((item: string, index: number) => (
                                <ParagraphLine key={index}
                                               className={`${s.predictiveMaintrance_text} ${s.predictiveMaintrance_fullWidthText}`}>{item}</ParagraphLine>
                            ))
                        }
                    </div>
                    <div
                        className={`${s.predictiveMaintrance_imageContainer} ${s.predictiveMaintrance_appAreas_imageContainer}`}>
                        <Image src={app_areas} alt={'app_areas'}/>
                    </div>
                    <div
                        className={`${s.predictiveMaintrance_imageContainer} ${s.predictiveMaintrance_appAreas_imageContainerSecond}`}>
                        <Image src={app_areas_second_variant} alt={'app_areas_second_variant'}/>
                    </div>
                </div>

                <div className={s.predictiveMaintrance_benefits}>
                    <Title title={t('benefitsBlock.title')}/>

                    <div
                        className={`${s.predictiveMaintrance_benefits_content} ${s.predictiveMaintrance_flexContainer}`}>
                        <div className={s.predictiveMaintrance_benefits_content_textBlock}>
                            <p className={s.predictiveMaintrance_text}>{t('benefitsBlock.text')}</p>
                            <ul className={s.predictiveMaintrance_benefits_content_list}>
                                {
                                    t.raw('benefitsBlock.list').map((item: string, index: number) => (
                                        <li key={index}
                                            className={`${s.predictiveMaintrance_text} ${s.predictiveMaintrance_benefits_content_list_item}`}>
                                            <span><ConfirmIcon/></span>
                                            {item}
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                        <div
                            className={`${s.predictiveMaintrance_benefits_content_imageContainer} ${s.predictiveMaintrance_imageContainer}`}>
                            <Image src={benefits} alt={'benefits'}/>
                        </div>
                    </div>
                </div>

                <div className={s.predictiveMaintrance_implementing}>
                    <Title title={t('implementingBlock.title')}/>

                    <div
                        className={`${s.predictiveMaintrance_flexContainer} ${s.predictiveMaintrance_implementing_textContainer}`}>
                        {
                            t.raw('implementingBlock.text').map((item: string, index: number) => (
                                <p key={index} className={s.predictiveMaintrance_text}>{item}</p>
                            ))
                        }
                    </div>

                    <p className={s.predictiveMaintrance_title}>{t('implementingBlock.label')}</p>

                    <div className={s.predictiveMaintrance_implementing_cardsContainer}>
                        {
                            implementingBlockData.map((item: TCardContentIcon, index: number) => (
                                <div key={index} className={s.predictiveMaintrance_implementing_card}>
                                    <div className={s.predictiveMaintrance_implementing_iconContainer}>
                                        <item.Icon/>
                                    </div>

                                    <label className={s.predictiveMaintrance_text}>{item.title}</label>
                                    <p className={s.predictiveMaintrance_text}>{item.description}</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className={s.predictiveMaintrance_parameterMonitoring}>
                    <Title title={t('parameterMonitoringBlock.title')}/>

                    <p className={s.predictiveMaintrance_title}>{t('parameterMonitoringBlock.firstBlock.title')}</p>
                    <p className={`${s.predictiveMaintrance_text} ${s.predictiveMaintrance_parameterMonitoring_text}`}>{t('parameterMonitoringBlock.firstBlock.text')}</p>

                    <div className={`${s.predictiveMaintrance_flexContainer} ${s.predictiveMaintrance_parameterMonitoring_flexContainer}`}>
                        {
                            t.raw('parameterMonitoringBlock.firstBlock.list').map((item: string, index: number) => (
                                <p key={index}
                                   className={`${s.predictiveMaintrance_parameterMonitoring_item} ${s.predictiveMaintrance_text}`}>
                                    <span><ConfirmIcon/></span>
                                    {item}
                                </p>
                            ))
                        }
                    </div>

                    <div className={`${s.predictiveMaintrance_imageContainer} ${s.predictiveMaintrance_parameterMonitoring_imageContainer}`}>
                        <Image src={parameter_monitoring_engine} alt={'parameter_monitoring_engine'}/>
                    </div>

                    <p className={s.predictiveMaintrance_title}>{t('parameterMonitoringBlock.secondBlock.title')}</p>

                    <div className={`${s.predictiveMaintrance_flexContainer} ${s.predictiveMaintrance_parameterMonitoring_flexContainer}`}>
                        {
                            t.raw('parameterMonitoringBlock.secondBlock.list').map((item: string, index: number) => (
                                <p key={index}
                                   className={`${s.predictiveMaintrance_parameterMonitoring_item} ${s.predictiveMaintrance_text}`}>
                                    <span><ConfirmIcon/></span>
                                    {item}
                                </p>
                            ))
                        }
                    </div>

                    <div className={`${s.predictiveMaintrance_imageContainer} ${s.predictiveMaintrance_parameterMonitoring_imageContainer}`}>
                        <Image src={parameter_monitoring_suspension} alt={'parameter_monitoring_suspension'}/>
                    </div>

                    <p className={s.predictiveMaintrance_title}>{t('parameterMonitoringBlock.thirdBlock.title')}</p>

                    <div className={s.predictiveMaintrance_parameterMonitoring_gridContainer}>
                        {
                            t.raw('parameterMonitoringBlock.thirdBlock.list').map((item: string, index: number) => (
                                <p key={index}
                                   className={`${s.predictiveMaintrance_parameterMonitoring_item} ${s.predictiveMaintrance_text}`}>
                                    <span><ConfirmIcon/></span>
                                    {item}
                                </p>
                            ))
                        }
                    </div>
                </div>

                <div className={s.predictiveMaintrance_telematicsEquipment}>
                    <Title title={t('telematicsEquipmentBlock.title')}/>

                    <div className={s.predictiveMaintrance_flexContainer}>

                        <div className={s.predictiveMaintrance_telematicsEquipment_card}>
                            {
                                t.raw('telematicsEquipmentBlock.text').map((item: string, index: number) => (
                                    <p key={index} className={s.predictiveMaintrance_text}>
                                        {index === ELEMENT_INDEX.SECOND && <span>{t('telematicsEquipmentBlock.boldText')}</span>}
                                        { item }
                                    </p>
                                ))
                            }
                        </div>

                        <div className={`${s.predictiveMaintrance_telematicsEquipment_imageContainer} ${s.predictiveMaintrance_imageContainer}`}>
                            <Image src={telematics_equipment} alt={'telematics_equipment'}/>
                        </div>
                    </div>
                </div>

                <SliderBlock
                    label={t('selectEquipment.title')}
                    navigationId={'select'}
                    data={t.raw('selectEquipment.cardsData')}
                    card={(item, index) => (
                        <>
                            <Link key={index} href={(item as TProductsSliderCardProps).href}
                                  className={`${s.predictiveMaintrance_selectEquipment_card} ${s.predictiveMaintrance_selectEquipment_cardLink}`}>
                                <label className={s.predictiveMaintrance_selectEquipment_label}>{item.label}</label>
                                <div
                                    className={`${s.predictiveMaintrance_selectEquipment_imageContainer} ${s.predictiveMaintrance_imageContainer}`}>
                                    <Image src={item.image} alt={item.label}/>
                                </div>
                            </Link>

                            <div key={index} className={`${s.predictiveMaintrance_selectEquipment_card} ${s.predictiveMaintrance_selectEquipment_cardBlock}`}>
                                <div className={s.predictiveMaintrance_selectEquipment_cardBlock_imageContent}>
                                    <div
                                        className={`${s.predictiveMaintrance_imageContainer} ${s.predictiveMaintrance_selectEquipment_imageContainer}`}>
                                        <Image src={item.image} alt={item.label}/>
                                    </div>
                                </div>
                                <div className={s.predictiveMaintrance_selectEquipment_cardBlock_content}>
                                    <label
                                        className={s.predictiveMaintrance_selectEquipment_label}>{item.label}</label>
                                    <TextIconLink href={(item as TProductsSliderCardProps).href} icon={<CircleArrowIcon/>}>See more</TextIconLink>
                                </div>
                            </div>
                        </>
                    )}
                />

                <ContactUs/>
            </Container>
        </div>
    );
};